import Connector from "@nextories/vue-core-components/src/utils/Connector";
import type { Slot } from "@nextories/vue-core-components/src/types/Meetings";
import type { PostSlot } from "@/types/Meeting";

export default class CustomerApi extends Connector {
  /**
   * Retrieve the project of the current user from the backend
   * @returns {Promise<Object>} resolve with the project for the current user
   * or reject with the backend error message
   */

  getMeetingsSlots(
    days: number,
    duration: number,
    date: string,
    query: string,
  ): Promise<any> {
    return this._methodData(
      "get",
      `/meeting/slot/${window.connector.projectToken}?days=${days}${duration ? `&duration=${duration}` : ''}&date=${date}&${query}`,
    );
  }

  postMeeting(request: Slot) {
    return this._methodData("post", `/meeting/slot/${window.connector.projectToken}`, request);
  }

  getOperatorsAmplitude(request: {}) {
    return this._methodData("post", "meeting/operators-amplitude", request);
  }

  // Start locks
  postLock(request: PostSlot) {
    return this._methodData('post', `/meeting/locks/create/${window.connector.projectToken}`, request);
  }

  deleteLock(id: string, request: {
    duration: string,
  }): Promise<any> {
    return this._methodData('post',`/meeting/locks/delete/${id}`, request);
  }
  // End locks
}
